// src/crypto.js
// Exports: deriveKeyFromPassphrase, encryptAES, decryptAES
export async function deriveKeyFromPassphrase1(passphrase) {
  const enc = new TextEncoder();
  const passBytes = enc.encode(passphrase);
  const hash = await crypto.subtle.digest("SHA-256", passBytes);
  // import as a raw AES-GCM key
  return crypto.subtle.importKey("raw", hash, "AES-GCM", false, ["encrypt", "decrypt"]);
}
async function deriveKeyFromPassphrase(passphrase) {
  const enc = new TextEncoder();
  const passBytes = enc.encode(passphrase);
  const hashBuffer = await crypto.subtle.digest("SHA-256", passBytes);
  return crypto.subtle.importKey(
    "raw",
    hashBuffer,
    "AES-GCM",
    false,
    ["decrypt"]
  );
}

export async function encryptAES(plainText, keyString) {
  const enc = new TextEncoder();
  const key = await crypto.subtle.importKey(
    "raw",
    enc.encode(keyString.padEnd(32, " ").slice(0, 32)),
    "AES-GCM",
    false,
    ["encrypt"]
  );

  const iv = crypto.getRandomValues(new Uint8Array(12));
  const cipherBuffer = await crypto.subtle.encrypt(
    { name: "AES-GCM", iv },
    key,
    enc.encode(plainText)
  );

  const combined = new Uint8Array(iv.length + cipherBuffer.byteLength);
  combined.set(iv, 0);
  combined.set(new Uint8Array(cipherBuffer), iv.length);

  return btoa(String.fromCharCode(...combined));
}

export async function decryptAES(base64Data, passphrase) {
  try {
    // Base64 → Uint8Array
    const raw = Uint8Array.from(atob(base64Data), c => c.charCodeAt(0));

    // First 12 bytes = IV
    const iv = raw.slice(0, 12);
    const data = raw.slice(12);

    // Derive key
    const key = await deriveKeyFromPassphrase(passphrase);

    // Decrypt
    const decryptedBuffer = await crypto.subtle.decrypt(
      { name: "AES-GCM", iv },
      key,
      data
    );

    const decryptedStr = new TextDecoder().decode(decryptedBuffer);

    // Try to parse JSON, fallback to string
    try {
      return JSON.parse(decryptedStr);
    } catch (err) {
      return decryptedStr;
    }
  } catch (err) {
    console.error("AES-GCM decryption failed:", err);
    throw err; // or return null
  }
}